import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const quoteDeleteAtom = createMutationAtomFactory(
  'brokerage.quoteDelete',
  (params: { id: string }) => ({
    tradeQuoteDelete: {
      __args: {
        id: params.id,
      },
    },
  }),
);
